export type AssistantCommentReplyMode = 'public_comment' | 'private_comment';

export type AssistantCommentReplyChannel = 'instagram' | 'messenger' | 'tiktok';

export const ASSISTANT_COMMENT_REPLY_CHANNELS: Array<{
  key: AssistantCommentReplyChannel;
  labelKey: string;
  available: boolean;
}> = [
  { key: 'instagram', labelKey: 'assistantBulkMuteChannelInstagram', available: true },
  { key: 'messenger', labelKey: 'assistantBulkMuteChannelMessenger', available: true },
  { key: 'tiktok', labelKey: 'assistantBulkMuteChannelTikTok', available: false },
];

export const ASSISTANT_COMMENT_REPLY_MODES: AssistantCommentReplyMode[] = [
  'public_comment',
  'private_comment',
];

export const resolveAssistantCommentReplyModeForChannel = (
  settings: Partial<Record<AssistantCommentReplyChannel, AssistantCommentReplyMode>>,
  channel: AssistantCommentReplyChannel,
  fallbackMode: AssistantCommentReplyMode = 'public_comment',
): AssistantCommentReplyMode => {
  const configured = settings[channel];
  return configured === 'private_comment' || configured === 'public_comment' ? configured : fallbackMode;
};
